import React, { Component } from "react";
import { CurrentTime } from "../../PlantListStyle";
import Clock from "react-live-clock";
import CountDownTimer from "../../../../commons/components/CountDownTimer/CountDownTimer";
import MS from "../../../../commons/services/Moment";
import CS from "../../../../commons/services/Common";
import PS from "../../MonitoringApiService";
import LineChart from "../../../../commons/components/LineChart";
import BarChart from "../../../../commons/components/BarChart";
import { withTranslation } from "react-i18next";

const REFRESH_SECONDS = 60;

class PowerGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refresh: false,
    }
    this.onRefresh = this.onRefresh.bind(this);
  }

onRefresh() {
  this.setState({ refresh: true }, () => {
    this.setState({ refresh: false });
  });
}
  render() {
    const { refresh } = this.state;
    const { t } = this.props;
    return (
      <div>
        <CurrentTime>
          <ul className="head">
            <li>{t('key168')}</li>
            <li>
              <Clock
                format={"YYYY.MM.DD HH:mm:ss"}
                ticking={true}
                timezone={"Asia/Seoul"}
              />
            </li>
          </ul>
          <CountDownTimer
            onRefresh={this.onRefresh}
            refreshSeconds={REFRESH_SECONDS}
            isInfinite={true}
          />
        </CurrentTime>
        <section className="power-plant-graph">
          <div className="container">
            <PowerDailyChart
              carrierSerialNos={this.props.carrierSerialNos || []}
              refresh={refresh}
              t={t}
            />
            <PowerMonthlyChart
              carrierSerialNos={this.props.carrierSerialNos || []}
              refresh={refresh}
              t={t}
            />
            <PowerYearlyChart
              carrierSerialNos={this.props.carrierSerialNos || []}
              refresh={refresh}
              t={t}
            />
          </div>
        </section>
      </div>
    );
  }
}

export default withTranslation()(PowerGraph);

class GraphHeader extends Component {
  render() {
    const { title, children } = this.props;
    return (
      <div className="f-stack">
        <h3 className="content-tit1">{title}</h3>
        <div className="pr-25">
          {children}
        </div>
      </div>
    )
  }
}

class GraphDateHandler extends Component {
  constructor(props) {
    super(props);
    const { defaultDate, type } = props;
    this.state = {
      nextDisabled: true,
      date: MS.format(defaultDate, "YYYY-MM-DD") || MS.format(new Date(), "YYYY-MM-DD"),
      type: type || "daily"
    }
    this.clickDateHandler = this.clickDateHandler.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.date !== this.state.date) {
      // 윤달 등 예외처리
      const monthly = MS.format(this.state.date, "YYYY-MM") >= MS.format(new Date(), "YYYY-MM");
      const daily = MS.format(this.state.date, "YYYY-MM-DD") >= MS.format(new Date(), "YYYY-MM-DD");
      const isEqual = this.state.type === "monthly" ? monthly : daily;
      if (isEqual) {
        this.setState({ nextDisabled: true });
      } else {
        this.setState({ nextDisabled: false });
      }
    }
  }

  clickDateHandler({
    type, // daily, monthly, yearly
    direction // "-", "+"
  }) {
    const { date } = this.state;
    const { onChange } = this.props;
    
    const newDate = MS.addAndFormat(
      date, 
      direction === "+" ? 1 : -1, 
      type === "daily" ? "days" : "months", "YYYY-MM-DD"
    );

    onChange && onChange(newDate);
    this.setState((prev) => ({ ...prev, date: newDate }));
  }

  render() {
    const { date, nextDisabled, type } = this.state;
    return (
      <div className="calendar">
        <div className="control">
          <button
            type="button"
            className="prev"
            onClick={() => this.clickDateHandler({ type, direction: "-" })}
          ></button>
          <strong className="date">
            <span className="year">{Number(MS.format(date, "YYYY"))}</span>
            <span className="month">{Number(MS.format(date, "MM"))}</span>&nbsp;
            {type === "daily" && <span className="day">{Number(MS.format(date, "DD"))}</span>}
          </strong>
          <button
            type="button"
            className="next"
            onClick={() => this.clickDateHandler({ type, direction: "+" })}
            disabled={nextDisabled}
          ></button>
        </div>
      </div>
    )
  }
}

class PowerDailyChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: MS.format(new Date(), "YYYY-MM-DD"),
      chartTodayHourlyData: {},
    }
    this.onChangeDate = this.onChangeDate.bind(this);
  }

  componentDidMount() {
    this.getTodayHourlyPower(this.state.date, this.props.carrierSerialNos);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.date !== prevState.date || this.props.carrierSerialNos !== prevProps.carrierSerialNos) {
      this.getTodayHourlyPower(this.state.date, this.props.carrierSerialNos);
    }

    if ((this.props.refresh !== prevProps.refresh) && this.props.refresh) {
      this.getTodayHourlyPower(this.state.date, this.props.carrierSerialNos);
    }
  }

  onChangeDate = (date) => {
    const newDate = MS.format(date, "YYYY-MM-DD");
    this.setState((prev) => ({ ...prev, date: newDate }));
  }

  getTodayHourlyPower = async (date, carrierSerialNos) => {
    const param = {
      isPeriod: false,
      carrierSerialNos: carrierSerialNos || [],
      dateType: "ymd",
      date: date,
      groupCols: ["hh"],
    };
    const hours = PS.getHourlyAxisx(date);
    const hourlyPower = await PS.getCarrierPowerList(param) || [];

    if (date === MS.format(new Date(), "YYYY-MM-DD")) {
      hourlyPower.push({
        _id: MS.format(new Date(), "HH"),
        power: this.state.currentHourPower,
      });
    }
    
    const data = PS.settingChartData(hours, hourlyPower);
    const chartData = {};
    chartData.labels = hours;
    chartData.datasets = CS.formatDecimalInArray(data, 1);
    this.setState({
      chartTodayHourlyData: chartData,
    });
  };

  render() {
    const { date, chartTodayHourlyData } = this.state;
    const { t } = this.props;
    return (
      <div style={{ marginBottom: "20px" }}>
        <GraphHeader title={t('key626')}> 
          <div className="chart-caption">
            <i className="circle-bg"></i>
            <strong className="mx-10">{t('key26')}</strong>
            <span className="tool-tip right">
              <span className="text w350">
                {t('key172')} {/* 해당 그래프는 하루동안 시간별로 소비된 소비전력 정보를 제공합니다. */}
              </span>
            </span>
          </div>
        </GraphHeader>
        <div className="card graph">
          <GraphDateHandler 
            type="daily"
            defaultDate={date}
            onChange={this.onChangeDate}
          />
          <div className="chart">
            <LineChart 
              text={t('key626')}
              labels={chartTodayHourlyData.labels}
              datasets={getLineChartDataSets(chartTodayHourlyData.datasets)}
            />
          </div>
        </div>
      </div>
    )
  }
}

class PowerMonthlyChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: MS.format(new Date(), "YYYY-MM"),
      chartData: {},
    }
  }

  componentDidMount() {
    this.getDailyPower(this.state.date, this.props.carrierSerialNos);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.date !== prevState.date || this.props.carrierSerialNos !== prevProps.carrierSerialNos) {
      this.getDailyPower(this.state.date, this.props.carrierSerialNos);
    }

    if ((this.props.refresh !== prevProps.refresh) && this.props.refresh) {
      this.getDailyPower(this.state.date, this.props.carrierSerialNos);
    }
  }

  onChangeDate = (date) => {
    const newDate = MS.format(date, "YYYY-MM");
    this.setState((prev) => ({ ...prev, date: newDate }));
  }

  getDailyPower = async (ym, carrierSerialNos) => {
    const param = {
      isPeriod: false,
      carrierSerialNos: carrierSerialNos || [],
      dateType: "ym",
      date: ym,
      groupCols: ["ymd"],
    };
    const dailyPowerList = await PS.getCarrierPowerList(param);
    const index = dailyPowerList?.findIndex((e, index, array) => {
      return e._id === MS.current("YYYY-MM-DD");
    });
    if (index > -1) {
      dailyPowerList[index].power =
        dailyPowerList[index].power + this.state.currentHourPower;
    }
    const labels = PS.getDailyAxisx(ym);
    const data = PS.settingChartData(labels, dailyPowerList);
    const chartData = {};
    chartData.labels = labels;
    chartData.datasets = CS.formatDecimalInArray(data, 1);
    this.setState({
      chartData: chartData,
    });
  };

  render() {
    const {
      date,
      chartData
    } = this.state;
    const { t } = this.props;
    return (
      <div style={{ marginBottom: "20px" }}>
        <GraphHeader title={t('key628')}>
          <div className="chart-caption">
            <i className="circle-bg"></i>
            <strong className="mx-10">{t('key26')}</strong>
            <span className="tool-tip right">
              <span className="text w350">
                해당 그래프는 한달동안 일별로 소비된 소비전력 정보를
                제공합니다.
              </span>
            </span>
          </div>
        </GraphHeader>
        <div className="card graph">
          <GraphDateHandler 
            type="monthly"
            defaultDate={date}
            onChange={this.onChangeDate}
          />
          <div className="chart">
            <BarChart 
              text={"소비전력 그래프(단위, kWh)"}
              labels={chartData.labels}
              datasets={getChartDataSets(chartData.datasets)}
            />
          </div>
        </div>
      </div>
    )
  }
}

class PowerYearlyChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cumulativeFromYear: Number(MS.format(new Date(), "YYYY")) - 1,
      cumulativeToYear: Number(MS.format(new Date(), "YYYY")),
      nextDisabled: true,
      activeTab: "ym",
      ymChartData: {},
      quarterChartData: {},
      yChartData: {}
    }
    this.clickDateHandler = this.clickDateHandler.bind(this);
    this.tabClickHandler = this.tabClickHandler.bind(this);
  }

  componentDidMount() {
    this.getAccumulationPowerForChart(this.state.cumulativeToYear, this.state.activeTab, this.props.carrierSerialNos);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.carrierSerialNos !== this.props.carrierSerialNos) {
      this.getAccumulationPowerForChart(this.state.cumulativeToYear, this.state.activeTab, this.props.carrierSerialNos);
    }

    if (prevState.activeTab !== this.state.activeTab) {
      this.getAccumulationPowerForChart(this.state.cumulativeToYear, this.state.activeTab, this.props.carrierSerialNos);
    }

    if (prevState.cumulativeToYear !== this.state.cumulativeToYear) {
      this.getAccumulationPowerForChart(this.state.cumulativeToYear, this.state.activeTab, this.props.carrierSerialNos);
    }

    if (prevProps.refresh !== this.props.refresh && this.props.refresh) {
      this.getAccumulationPowerForChart(this.state.cumulativeToYear, this.state.activeTab, this.props.carrierSerialNos);
    }
  }

  clickDateHandler(step) {
    let fromYear = this.state.cumulativeFromYear;
    let toYear = this.state.cumulativeToYear;
    fromYear = step == "+" ? fromYear + 1 : fromYear - 1;
    toYear = step == "+" ? toYear + 1 : toYear - 1;
    this.setState({
      cumulativeFromYear: fromYear,
      cumulativeToYear: toYear,
      nextDisabled:
        fromYear < MS.format(new Date(), "YYYY") ? "" : "disabled",
    });
  }

  tabClickHandler(tab) {
    this.setState({ activeTab: tab });
  }

  getAccumulationPowerForChart = async (y, activeTab, carrierSerialNos) => {
    let chartDatas = [];
    for (let i = 0; i < 2; i++) {
      const param = {
        isPeriod: false,
        carrierSerialNos: carrierSerialNos || [],
        dateType: "y",
        date: y - i,
        groupCols: [activeTab],
      };
      const powerList = await PS.getCarrierPowerList(param) || [];
      
      let index = -1;
      const chartLabels = [];
      let labels = [];
      if (activeTab == "ym") {
        labels = PS.getMonthlyAxisx(y - i);
        labels.some((v) => {
          chartLabels.push(Number(v.substring(5)));
        });
        index = powerList?.findIndex((e, index, array) => {
          return e._id == MS.current("YYYY-MM");
        });
      } else if (activeTab == "quarter") {
        labels = ["1", "2", "3", "4"];
        labels.some((v) => {
          chartLabels.push(v);
        });
        index = powerList?.findIndex((e, index, array) => {
          return e._id === MS.currentQuarter();
        });
      } else {
        labels = [(y - i).toString()];
        chartLabels.push((y - i).toString());
        index = powerList?.findIndex((e, index, array) => {
          return e._id == MS.current("YYYY");
        });
      }

      if (index > -1) {
        powerList[index].power =
          Number(powerList[index].power) + (this.state.currentHourPower || 0);
      }

      const data = PS.settingChartData(labels, powerList);
      const chartData = {};
      chartData.labels = chartLabels;
      chartData.datasets = CS.formatDecimalInArray(data, 1);
      chartDatas.push(chartData);
    }

    if (activeTab == "y") {
      const yLabel = [];
      const yDatasets = [];
      chartDatas.some((v) => {
        yLabel.push(v.labels[0]);
        yDatasets.push(v.datasets[0]);
      });
      chartDatas.labels = yLabel;
      chartDatas.datasets = yDatasets;
    }

    this.setState((prev) => ({
      ...prev,
      [activeTab + "ChartData"]: chartDatas,
    }));
  };

  render() {
    const { 
      cumulativeFromYear, 
      cumulativeToYear, 
      nextDisabled, 
      activeTab,
      ymChartData,
      quarterChartData,
      yChartData
    } = this.state;
    const { t } = this.props;
    return (
      <div style={{ marginBottom: "20px" }}>
        <GraphHeader title={t('key629')}>
          <div className="calendar sm gray">
            <div className="control">
              <button
                type="button"
                className="prev"
                onClick={() => this.clickDateHandler("-")}
              >
                <strong>이전달</strong>
              </button>
              <strong className="date">
                <span className="year">{cumulativeFromYear}</span>
                <span className="year">{cumulativeToYear}</span>
              </strong>
              <button
                type="button"
                className="next"
                onClick={() => this.clickDateHandler("+")}
                disabled={nextDisabled}
              >
                <strong>다음달</strong>
              </button>
            </div>
          </div>
        </GraphHeader>
        <div className="card cumulative-power">
          <div id="chartTabPanel" className="tabs-wrapper">
            <nav className="tab-menu">
              <a
                onClick={() => this.tabClickHandler("ym")}
                className={activeTab === "ym" ? "active" : ""}
              >
                {t('key630')} {/* 월간 */}
              </a>
              <a
                onClick={() => this.tabClickHandler("quarter")}
                className={activeTab === "quarter" ? "active" : ""}
              >
                {t('key631')} {/* 분기 */}
              </a>
              <a
                onClick={() => this.tabClickHandler("y")}
                className={activeTab === "y" ? "active" : ""}
              >
                {t('key632')} {/* 연간 */}
              </a>
            </nav>
          </div>
          <div className="tab-contents">
            <div
              id="tabs-1"
              className="tab-panel"
              style={
                activeTab == "ym"
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              {!CS.checkIsEmptyObject(ymChartData) ? (
                <BarChart
                  id="powerCarrierMonth"
                  text="누적 전력소비량(월간)"
                  labels={ymChartData[0].labels}
                  datasets={getMultiChartDataSets(ymChartData, 2, cumulativeToYear)}
                />
              ) : (
                <></>
              )}
            </div>
            <div
              id="tabs-2"
              className="tab-panel"
              style={
                activeTab == "quarter"
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              {!CS.checkIsEmptyObject(quarterChartData) ? (
                <BarChart
                  id="powerCarrierQuarter"
                  text="누적 전력소비량(분기별)"
                  labels={quarterChartData[0].labels}
                  datasets={getMultiChartDataSets(
                    quarterChartData,
                    2,
                    cumulativeToYear
                  )}
                />
              ) : (
                <></>
              )}
            </div>
            <div
              id="tabs-3"
              className="tab-panel"
              style={
                activeTab == "y"
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              {!CS.checkIsEmptyObject(yChartData) ? (
                <BarChart
                  id="powerCarrierYear"
                  text="누적 전력소비량(연간)"
                  labels={yChartData.labels}
                  datasets={getChartDataSets(yChartData.datasets)}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}


//helper 

function getLineChartDataSets(data) {
  let datasets = [];
  let dataset = {
    label: ["소비전력(W)"],
    fill: false,
    lineTension: 0.3,
    backgroundColor: "rgba(214,247,26,0.4)",
    borderColor: "#d6f71a",
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0.0,
    borderJoinStyle: "miter",
    pointBorderColor: "rgba(214,247,26,1)",
    pointBackgroundColor: "#fff",
    pointBorderWidth: 1,
    pointHoverRadius: 5,
    pointHoverBackgroundColor: "rgba(214,247,26,1)",
    pointHoverBorderColor: "rgba(220,220,220,1)",
    pointHoverBorderWidth: 2,
    pointRadius: 3,
    pointHitRadius: 10,
    data: data,
  };
  datasets.push(dataset);
  return datasets;
}

function getChartDataSets(data) {
  let datasets = [];
  let dataset = {
    label: ["소비전력"],
    backgroundColor: "#d6f71a",
    borderColor: "#c5e319",
    borderWidth: 2,
    data: data,
  };
  datasets.push(dataset);
  return datasets;
}

function getMultiChartDataSets(data, cnt, cumulativeToYear) {
    let datasets = [];
    for (let i = 0; i < cnt; i++) {
      let dataset = {
        label: Number(cumulativeToYear) - i,
        backgroundColor: i === 0 ? "#d6f71a" : "#eefc9a",
        borderColor: i === 0 ? "#c5e319" : "#e4fa64",
        borderWidth: 2,
        order: 2 - i,
        data: data[i].datasets,
      };
      datasets.push(dataset);
    }
    return datasets;
}